import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page2"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
const _hoisted_25 = ["src"];
import '@/assets/v2/page2/page2.css';
import gohomeImage from '@/assets/v2/page2/gohome.webp'; // 导入图片
import konngjian from '@/assets/v2/page2/konngjian.webp';
import changjing from '@/assets/v2/page2/changjing.webp';
import chanpin from '@/assets/v2/page2/chanpin.webp';
import CONTENTS from '@/assets/v2/page2/CONTENTS.webp';
import xingzhuang7 from '@/assets/v2/page2/xingzhuang7.webp';
import one from '@/assets/v2/page2/a1/01.webp';
import Product from '@/assets/v2/page2/a1/Product.webp';
import MANSION from '@/assets/v2/page2/a1/MANSION.webp';
import Productview from '@/assets/v2/page2/a1/Productview.webp';
import xingzhuang from '@/assets/v2/page2/a1/xingzhuang.webp';
import two from '@/assets/v2/page2/a2/02.webp';
import Space from '@/assets/v2/page2/a2/Space.webp';
import SpaceScript from '@/assets/v2/page2/a2/SpaceScript.webp';
import three from '@/assets/v2/page2/a3/03.webp';
import Scene from '@/assets/v2/page2/a3/Scene.webp';
import SceneDisplay from '@/assets/v2/page2/a3/SceneDisplay.webp';
import click from '@/assets/v2/image.webp';
// 将goHome函数传递给父组件

export default {
  __name: 'Page2',
  emits: ['goHome', 'scrollToPage2'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const scrollToPage2 = page => {
      console.log('page2', page);
      emit('scrollToPage2', page);
    };
    const gohome = () => {
      emit('goHome');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(gohomeImage),
        alt: "gohomeImage",
        class: "gohomeImage",
        onClick: gohome,
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(CONTENTS),
        alt: "CONTENTS",
        class: "CONTENTS",
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("img", {
        src: _unref(xingzhuang7),
        alt: "xingzhuang7",
        class: "xingzhuang7",
        loading: "lazy"
      }, null, 8, _hoisted_4), _createElementVNode("img", {
        src: _unref(chanpin),
        alt: "chanpin",
        class: "chanpin",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(konngjian),
        alt: "konngjian",
        class: "konngjian",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: _unref(changjing),
        alt: "changjing",
        class: "changjing",
        loading: "lazy"
      }, null, 8, _hoisted_7), _createElementVNode("div", {
        class: "wenzi",
        onClick: _cache[0] || (_cache[0] = $event => scrollToPage2(2))
      }, [_createElementVNode("img", {
        src: _unref(click),
        alt: "",
        class: "click pulse-animation"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(one),
        alt: "one",
        class: "one",
        loading: "lazy"
      }, null, 8, _hoisted_9), _createElementVNode("img", {
        src: _unref(Product),
        alt: "Product",
        class: "Product",
        loading: "lazy"
      }, null, 8, _hoisted_10), _createElementVNode("img", {
        src: _unref(MANSION),
        alt: "MANSION",
        class: "MANSION",
        loading: "lazy"
      }, null, 8, _hoisted_11), _createElementVNode("img", {
        src: _unref(Productview),
        alt: "Productview",
        class: "Productview",
        loading: "lazy"
      }, null, 8, _hoisted_12), _createElementVNode("img", {
        src: _unref(xingzhuang),
        alt: "xingzhuang",
        class: "xingzhuang",
        loading: "lazy"
      }, null, 8, _hoisted_13)]), _createElementVNode("div", {
        class: "wenzi2",
        onClick: _cache[1] || (_cache[1] = $event => scrollToPage2(4))
      }, [_createElementVNode("img", {
        src: _unref(click),
        alt: "",
        class: "click pulse-animation"
      }, null, 8, _hoisted_14), _createElementVNode("img", {
        src: _unref(two),
        alt: "two",
        class: "two",
        loading: "lazy"
      }, null, 8, _hoisted_15), _createElementVNode("img", {
        src: _unref(Space),
        alt: "Space",
        class: "Space",
        loading: "lazy"
      }, null, 8, _hoisted_16), _createElementVNode("img", {
        src: _unref(MANSION),
        alt: "MANSION",
        class: "MANSION2",
        loading: "lazy"
      }, null, 8, _hoisted_17), _createElementVNode("img", {
        src: _unref(SpaceScript),
        alt: "SpaceScript",
        class: "SpaceScript",
        loading: "lazy"
      }, null, 8, _hoisted_18), _createElementVNode("img", {
        src: _unref(xingzhuang),
        alt: "xingzhuang",
        class: "xingzhuang2",
        loading: "lazy"
      }, null, 8, _hoisted_19)]), _createElementVNode("div", {
        class: "wenzi3",
        onClick: _cache[2] || (_cache[2] = $event => scrollToPage2(8))
      }, [_createElementVNode("img", {
        src: _unref(click),
        alt: "",
        class: "click pulse-animation"
      }, null, 8, _hoisted_20), _createElementVNode("img", {
        src: _unref(three),
        alt: "three",
        class: "three",
        loading: "lazy"
      }, null, 8, _hoisted_21), _createElementVNode("img", {
        src: _unref(Scene),
        alt: "Scene",
        class: "Scene",
        loading: "lazy"
      }, null, 8, _hoisted_22), _createElementVNode("img", {
        src: _unref(SceneDisplay),
        alt: "SceneDisplay",
        class: "SceneDisplay",
        loading: "lazy"
      }, null, 8, _hoisted_23), _createElementVNode("img", {
        src: _unref(MANSION),
        alt: "MANSION",
        class: "MANSION3",
        loading: "lazy"
      }, null, 8, _hoisted_24), _createElementVNode("img", {
        src: _unref(xingzhuang),
        alt: "xingzhuang",
        class: "xingzhuang3",
        loading: "lazy"
      }, null, 8, _hoisted_25)])]);
    };
  }
};